import axios from 'axios';

import { Broadcaster } from './types';

export async function getBroadcasters(baseURL: string): Promise<Broadcaster[]> {
  const response = await axios.get(`${baseURL}/broadcasters?fields=callSign`);
  return response.data;
}
